import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Resources/FreightForwarder/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>      
      <div className={cn('header__image-box')}>
        <img
          className={cn('header__image')}
          src="/images/pages/Resources/FreightForwarder/map.webp"
          alt="Logistics & Freight Map"
        />
      </div>

      <div className={cn('container')}>
      <Breadcrumbs mTop={8} mode="light" links={[{ title: 'Freight Forwarder', href: '' as Route }]} />

        <div className={cn('header__content')}>
          <div className={cn('header__heading-box')}>
            <h1 className={cn('header__heading')}>How to Become a Freight Forwarder</h1>
            <p className={cn('header__heading-description')}>
              Find the requirements to become a freight forwarding member of the DF Alliance network and boost your
              logistic capabilities by using our digital freight forwarding tools.
            </p>

            <div className={cn('header__buttons')}>
              {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
              {/* <Link className={cn('header__button-register')} href="/membership">
                Register
              </Link> */}
              <Link className={cn('header__button-more')} href="/company/contact-us">
                Show more
                <svg viewBox="0 0 10 10" aria-hidden="true">
                  <path d="M1 5h7" />
                  <path d="M2 1l4 4-4 4" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
